/**
 * expertiseStandingConstants — the constants shared by the expertise ring
 * stores (`useExpertiseStanding`, the viewer's own standing;
 * `useNetworkExpertiseOverlap`, the viewer's network), the map-presence and
 * Track Record stores (`stores/mapPresence.js`, `stores/trackRecord.js`) —
 * all DEBOUNCE_MS — and the ring's one reader (`utils/standingRing.js`,
 * `tierPriority`).
 *
 * A dependency-free leaf: frozen constants and one pure function, no imports.
 * A module that needs only these never pulls in an h3-js-dependent geometry
 * module, so a suite that mocks geometry still reads the real values from here.
 *
 * Deliberately absent: any score → tier table and any rung threshold. The rung
 * is the server's answer; the client ranks rung labels and never derives one.
 */

/** Debounce (ms) between a viewport change and the recomputation / refetch it triggers */
export const DEBOUNCE_MS = 300

/**
 * Ordinal of each display tier, for ranking cells. An unknown or absent label
 * ranks 0 (no tier) — see `tierPriority`.
 */
export const TIER_PRIORITY = Object.freeze({ expert: 3, established: 2, emerging: 1 })

/** Rank of a display tier label; an unknown or absent label ranks 0 (no tier). */
export function tierPriority(tier) {
  return TIER_PRIORITY[tier] || 0
}
